module.exports = __webpack_public_path__ + "img/ennetix-deployment.2325e46e.png";